<div class="container-fluid container-background">


    <!-- header row top bar contains title, menu, options -->
    <div class="row">

        <!-- affixed header box sets padding for right menu -->
        <div class="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 bgwhite">

            <div class="outer">
                <div class="middle">

                    <div class="login-form-container">


                        <div class="login-header-title">
                            <i class="zmdi zmdi-lock zdmi-fw"></i> Account sign in
                        </div>
                        <div *ngIf="twofaRequired">
                            <p>Verify your identity by entering the 2FA code from your email or linked authenticator app.</p>
                            <br />
                        </div>
                        <div *ngIf="ctx == 'share'" class="alert alert-info">
                            Log in to join the shared folder <strong>{{shareFolderName}}</strong>
                            <span class="label label-default">{{shareLabel | b64}}</span>
                        </div>
                        <div *ngIf="error" class="error-general-overlay error-general-overlay-login">
                            <div class="row">
                                <div class="col-xs-12"><i class="fas fa-exclamation-triangle"></i> {{error.code}}
                                    {{error.msg}}</div>
                            </div>
                        </div>
                        <div *ngIf="verified" class="error-general-overlay error-general-overlay-login">
                            <div class="row">
                                <div class="col-xs-12"><i class="fas fa-check"></i> Your account has been verified,
                                    please log in.</div>
                            </div>
                        </div>
                        <div *ngIf="passwordset" class="error-general-overlay error-general-overlay-login">
                            <div class="row">
                                <div class="col-xs-12"><i class="fas fa-check"></i> Password for your account is set,
                                    please log in.</div>
                            </div>
                        </div>
                        <div *ngIf="passwordreset" class="alert alert-info">
                            <i class="ion-checkmark-circled fa-lg syncblue"></i>
                            Your new password has been saved, please log in.
                        </div>
                        <form (submit)="loginForm.valid && onSubmit()" [formGroup]="loginForm" method="post"
                            ngNativeValidate>

                            <div *ngIf="!twofaRequired">
                                <div class="form-group">
                                    <label for="exampleInputEmail1">Username:</label>
                                    <input type="email" placeholder="" value="" id="text-auth-email"
                                        formControlName="username" required
                                        class="input-lg form-control login-form-control" name="email" />
                                </div>

                                <div class="form-group">
                                    <label for="exampleInputPassword1">Password:</label>
                                    <input required type="password"
                                        class="form-control login-form-control input-lg" id="text-auth-password"
                                        name="password" formControlName="password" placeholder="" syncShowHidePassword identity="loginpass"/>
                                </div>

                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox" formControlName="rememberme" /> Keep me signed in
                                    </label>
                                </div>
                            </div>
                            <div *ngIf="twofaRequired">
                                <div class="form-group">
                                    <label>2 FA code:</label>
                                    <input type="text" placeholder="" value="" id="text-auth-twofacode"
                                        formControlName="twofacode" class="input-lg form-control login-form-control"
                                        name="twofacode" />
                                </div>
                                <input type="hidden" id="text-auth-password" name="password"
                                    formControlName="password" />
                                <input type="hidden" id="text-auth-email" formControlName="username" />
                                <input type="hidden" formControlName="rememberme" />
                            </div>
                            <div class="progress login-progress">
                                <div class="progress-bar" role="progressbar" [ngStyle]="{'width':loginProgress +'%'}">
                                </div>
                            </div>
                            <button id="btn-auth-login" [disabled]="!loginForm.valid || spinner" type="submit"
                                class="btn-block btn btn-primary btn-lg btn-login showhand">Sign in</button>



                            <div class="login-link" *ngIf="!twofaRequired">
                                <a routerLink="/forgotpassword" class="syncblue showhand">Forgot password?</a>
                                <a class="visible-xs syncblue showhand pull-right"
                                    href="https://www.sync.com/signup?from=cpsignout">Create account</a>
                            </div>

                        </form>

                        <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true"
                            *ngIf="twofaRequired">
                            <div class="panel panel-default" [id]="'panel' + i"
                                *ngFor="let content of accordianContent; index as i">
                                <div class="panel-heading" role="tab" [id]="'heading' + i">
                                    <h4 class="panel-title">
                                        <a role="button" [href]="'#collapse' + i"
                                            (click)="$event.preventDefault();toggleAccordian(i)" data-toggle="collapse"
                                            data-parent="#accordion" aria-expanded="true"
                                            [attr.aria-controls]="'collapse' + i">
                                            {{content.title}}
                                            <span class="fa fa-angle-down"></span>
                                        </a>
                                    </h4>
                                </div>
                                <div [id]="'collapse' + i" class="panel-collapse collapse" role="tabpanel"
                                    [attr.aria-labelledby]="'heading' + i">
                                    <div class="panel-body">
                                        <p *ngFor="let para of content.paras" [innerHTML]="para"></p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div> <!-- login form conteiner -->

                </div> <!-- middle -->
            </div> <!-- outer -->


        </div>
        <div class="hidden-xs col-sm-6 col-md-7 col-lg-7 col-xl-8">
            <!-- future -->

        </div>



    </div> <!-- row -->

</div>